import React from 'react';
import { Stack, Typography } from '@mui/material';

const SubHeader = () => {
	const completed = false;
	return (
		<Stack
			direction='row'
			justifyContent={completed ? 'center' : 'left'}
			alignItems='top'
			flexWrap='wrap'
			height='170px'
		>
			{!completed && (
				<Stack mx={30}>
					<Typography variant='h3' component='h2' fontWeight='bold'>
						Checkout
					</Typography>
				</Stack>
			)}
			{completed && (
				<Stack mx={30}>
					<Typography variant='h3' component='h2' fontWeight='bold'>
						Thank you for signing up for RizzBates!
					</Typography>
					<Typography fontWeight='bold' textAlign='center'>
						Your subscription number is #######
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default SubHeader;
